import { render, staticRenderFns } from "./vue-danmaku.vue?vue&type=template&id=1da4afae&"
import script from "./vue-danmaku.vue?vue&type=script&lang=js&"
export * from "./vue-danmaku.vue?vue&type=script&lang=js&"
import style0 from "./vue-danmaku.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports